import { render, staticRenderFns } from "./CombinedDrawers.vue?vue&type=template&id=0b1d8015&"
import script from "./CombinedDrawers.vue?vue&type=script&lang=js&"
export * from "./CombinedDrawers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports